export default __webpack_public_path__ + "photo-apropos-2.41ee398.png";